import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { IconLocationNotAvailable } from "src/components/icons-mui/location-not-available";
import { DeclareInterestButton } from "src/components-mui/common/buttons/declare-interest-button/declare-interest-button";
import { CBDetailsAccordion } from "../components/details-accordion";
import { CBFooter } from "../components/footer";
import { CBHeader } from "../components/header/header";
import { InfoBox } from "../components/info-box";
import { CBInvestedCapital } from "../components/invested-capital";
import { CBPrices } from "../components/prices";
import { CBRatioTabBar } from "../components/ratio-tab-bar";
import { SpacedContainer } from "../components/spaced-container";
import { CBCertificateFee, CBEmission, CBExchangeRatio, CBLiquidationFigure, CBPerformanceFee, CBTradingVolume } from "../components/statistics";
import { useCertificateBoxContext } from "../context";

const NOT_LICENSED_MESSAGE_TEST_ID = "not-licensed-message";
const FIND_INVESTABLE_BUTTON_TEST_ID = "find-investable-button";

export const CertificateBoxNotLicensedAll = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <CBPrices />
                <Divider />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Box>
                <Divider />

                <CBDetailsAccordion>
                    <Stack sx={{ gap: 1 }}>
                        <CBEmission />
                        <CBLiquidationFigure />
                        <CBTradingVolume />
                        {isHiddenCertificate && <CBExchangeRatio />}
                    </Stack>
                    <Divider sx={{ pt: 2 }} />
                </CBDetailsAccordion>

                <InfoBox icon={<IconLocationNotAvailable sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography fontSize="sm" data-test-id={NOT_LICENSED_MESSAGE_TEST_ID}>
                        {dict.notLicensedMessage}
                    </Typography>
                </InfoBox>

                <Stack spacing={1}>
                    {certificate.findInvestableUrl && (
                        <Button
                            component="a"
                            href={certificate.findInvestableUrl}
                            color="green"
                            size="medium"
                            data-test-id={FIND_INVESTABLE_BUTTON_TEST_ID}
                        >
                            {dict.findInvestableButton}
                        </Button>
                    )}
                    <DeclareInterestButton variant="outlined" size="medium" wikifolioId={data.wikifolio.id}>
                        {dict.declareInterestButton}
                    </DeclareInterestButton>
                </Stack>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
